<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">我的红包</h3>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="未使用的红包" name="unused">
        <RedPacks :status="1"></RedPacks>
      </el-tab-pane>
      <el-tab-pane label="已失效红包" name="invalid">
        <RedPacks :status="2"></RedPacks>
      </el-tab-pane>
      <el-tab-pane label="已使用红包" name="used">
        <RedPacks :status="3"></RedPacks>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import RedPacks from './redPackList';
export default {
  name: 'myRedPack',
  components: {
    RedPacks
  },
  data() {
    return {
      activeTab: 'unused',
    }
  }
};
</script>

<style scoped lang="less">
.headerTitle {
  font-size: 20px;
  color: #666;
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/myRedPack.vue